import axios from "axios";
const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(
  function (config) {
    const baseurl = process.env.REACT_APP_API_BASE_URL;
    config.baseURL = baseurl;
    const token = sessionStorage.getItem("userToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  function (response) {

    if (
      response?.data?.encryptedData?.code === "APP_MAINTENANCE"
    ) {
      window.location.href = "/maintenance";
    }

    return response;
  },
  function (error) {

    if (
      error?.response?.data?.encryptedData?.code === "APP_MAINTENANCE"
    ) {
      window.location.href = "/maintenance";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;